import React from "react";

/**
 * Renders a schema.org JSON-LD block as a <script type="application/ld+json">
 * tag, suitable for injecting into the document <head>.
 *
 * Used by:
 *   - gatsby-ssr.tsx (site-wide Organization + WebSite schema)
 *   - SEO component (per-page schemas passed via the `schema` prop)
 *   - Individual page Head exports (via SEO or directly)
 *
 * The `schema` prop is the parsed JSON-LD object — typically a `@graph` block
 * containing one or more schema.org entities. It will be stringified at render
 * time. Use `dangerouslySetInnerHTML` because React would otherwise escape
 * characters and break JSON parsing on the client.
 */
interface SchemaMarkupProps {
  /** Parsed schema.org JSON-LD object (usually with `@context` + `@graph`). */
  schema: object;
}

export function SchemaMarkup({ schema }: SchemaMarkupProps) {
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
